import { LANGUAGE_OPTIONS, type Language } from '@/admin/languages';
import { readTableSearch, writeTableSearch } from '@/admin/ui/tableSearch';

/**
 * The keys `createTablePage` keeps in the URL. A route's `validateSearch`
 * strips unknown keys, so it must pass these through for `urlState`. Read and
 * written back through tableSearch so the key list lives in one place.
 */
export function tableSearchKeys(
  search: Record<string, unknown>,
): Record<string, unknown> {
  return writeTableSearch({}, readTableSearch(search));
}

export function parseLanguage(value: unknown): Language | undefined {
  return LANGUAGE_OPTIONS.find(([code]) => code === value)?.[0];
}

export function parsePositiveInt(value: unknown): number | undefined {
  const n = Number(value);
  return Number.isInteger(n) && n >= 1 ? n : undefined;
}

export function parseBool(value: unknown): boolean | undefined {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return undefined;
}
